import { render, staticRenderFns } from "./Session.vue?vue&type=template&id=0ff890f7&"
import script from "./Session.vue?vue&type=script&lang=js&"
export * from "./Session.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff890f7')) {
      api.createRecord('0ff890f7', component.options)
    } else {
      api.reload('0ff890f7', component.options)
    }
    module.hot.accept("./Session.vue?vue&type=template&id=0ff890f7&", function () {
      api.rerender('0ff890f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/Session.vue"
export default component.exports